<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style>
	page {
		background-color: #FFFFFF;
		font-size: 28rpx;
		line-height: 1.5;
		/* H5 端设置页面最大宽度，避免过窄 */
		max-width: 100%;
		min-width: 320px;
	}
	
	/* H5 端容器样式优化 */
	/* #ifdef H5 */
	.uni-page-body {
		width: 100%;
		min-width: 320px;
	}
	/* #endif */
	
	view, text, image {
		box-sizing: border-box;
	}
</style>
